import { BehaviorSubject } from 'rxjs';
import {
  FormV3InvalidField,
  QuestionV3Constraint,
  VideoInfoType
} from '../models/dynamic-form-v3.models';
import { ConditionalRuleType, QuestionV3ControlTypes } from './enum';

export abstract class QuestionBaseV3 {
  readonly controlType: QuestionV3ControlTypes;

  type: string;
  key: string;
  value: any;
  label: string;
  page: number;
  order: number;
  display: boolean;
  disabled: boolean;
  readonly: boolean;
  required: boolean;
  customClasses: string[];
  conditionalRules: Array<ConditionalRuleType>;
  constraints: QuestionV3Constraint[];
  placeholder: string;
  infos = '';
  css: any;
  condition: any;
  compulsoryCondition: any;
  limitCondition: any;
  isHeadline: boolean;
  validators: Array<any>;
  hasCondition: boolean;
  video: VideoInfoType;
  pattern: string;

  private errorsSource = new BehaviorSubject<string[]>([]);
  errors$ = this.errorsSource.asObservable();

  private isDataToCheckSource = new BehaviorSubject<boolean>(false);
  isDataToCheck$ = this.isDataToCheckSource.asObservable();

  get errors(): string[] {
    return this.errorsSource.value;
  }

  set errors(errors: string[]) {
    this.errorsSource.next(errors);
  }

  get isDataToCheck(): boolean {
    return this.isDataToCheckSource.value;
  }

  protected constructor(options: any = {}) {
    this.key = options.key || '';
    this.value = options.value || void 0;
    this.label = options.label || '';
    this.page = options.page || 0;
    this.order = options.order === void 0 ? 1 : options.order;
    this.display = options.display || false;
    this.disabled = options.disabled || false;
    this.readonly = options.readonly || false;
    this.required = options.required || false;
    this.customClasses = options.customClasses || [];
    this.conditionalRules = options.conditionalRules || void 0;
    this.constraints = options.constraints || [];
    this.placeholder = options.placeholder || void 0;
    this.css = options.css || void 0;
    this.condition = options.condition;
    this.compulsoryCondition = options.compulsoryCondition;
    this.limitCondition = options.limitCondition;
    this.isHeadline = options.isHeadline;
    this.validators = options.validators || [];
    this.hasCondition = options.hasCondition;
    this.video = options.video;
    this.pattern = options.pattern || void 0;
  }

  checkIfIsInvalid(invalidFields: FormV3InvalidField[]): void {
    const found = invalidFields.find(field => field.questionKey === this.key);
    this.errorsSource.next((found && found.messages) || []);
  }

  checkIfIsDataToCheck(dataToCheckFields: string[]): void {
    const found = dataToCheckFields.find(key => key === this.key);
    this.isDataToCheckSource.next(!!found);
  }
}
